<template>
  <div>
    <div
      class="notifications__head d-flex justify-content-between align-items-center p-2">
      <div class="d-flex align-items-center">
        <div>
          <img
            v-if="notification.eventComment.createdBy.avatar"
            class="img-fluid rounded-circle member__img--notification mr-2"
            :src="notification.eventComment.createdBy.avatar">
          <b-avatar
            v-else
            :text="notification.eventComment.createdBy.name | initial"
            class="mr-2" />
        </div>
        <div class="member__content">
          <p class="member__name mr-2">
            {{ notification.eventComment.createdBy.name }}
          </p>
        </div>
        <p
          class="member__title">
          {{ notification.eventComment.createdBy.position }}
        </p>
      </div>
    </div>
    <div
      class="p-2">
      <div class="d-flex align-items-center py-1">
        <span class="side-nav__icon material-icons">
          event
        </span>

        <p class="font-weight-bold pr-2">
          予定表
        </p>
        <p
          v-if="event"
          class="font-weight-bold">
          {{ event.startAt | formatJPDate }}
        </p>
      </div>
      <notification-card-event-panel
        :event-comment="notification.eventComment"
        :event="event"
        @click-notification="onClickNotification" />
    </div>
  </div>
</template>

<script>
import format from 'date-fns/format'
import ja from 'date-fns/locale/ja'
import NotificationCardEventPanel from '@/components/view/NotificationCardEventPanel'

export default {
  components: {
    NotificationCardEventPanel,
  },
  filters: {
    formatJPDate(dateStr) {
      return format(new Date(dateStr), 'M月d日(E)', { locale: ja })
    }
  },
  props: {
    notification: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      default: null
    },
  },
  methods: {
    async onClickNotification() {
      this.$emit('click-notification', this.notification.id)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';

.member__img--notification {
  width: 30px;
  height: 30px;
  object-fit: cover;
}

</style>